import React from 'react';
import './style.css'
import { Card, Col, Row } from "react-bootstrap";
import {Link} from "react-router-dom";
import ProtectedAccess  from '../../../components/ProtectedAccess'
import { useNavigate } from "react-router-dom";

export default function AuthorItem (props) {

    const { author, handleShow }=props;
    
    const navigate = useNavigate();

    const truncate =(str)=>{
        if(!str) return "Descripción no disponible";
        return str.length > 100 ? `${str.substring(0, 100)} ...` : str;
    }

    const goToPage=(author)=>{
        navigate(`/editorial/authors/${author._id}`);
    }
    // TODO: cambiar idioma

    return (
        <Col xs={6} sm={6} md={6} xl={4} style={{ /* minWidth:'330px' */ }}>
            <Card className="author-item">
                <Row className="g-0 " style={{ padding: 0 }}>
                    <Col sm={4} className="position-relative">
                        <Card.Img onClick={()=>goToPage(author)}  src={author.photo || '/assets/app/author.png'} className="fit-cover w-100 h-100 image-link" alt=""/>
                        <ProtectedAccess 
                            element={
                                <button className="btn btn-sm btn-primary badge" type="button" onClick={()=>handleShow(author)} > Modificar</button>
                            }
                            role={['admin', 'editor']}
                        />
                    </Col>
                    <Col sm={8}>
                        <Card.Body style={{padding:'1rem'}}>
                            <strong>
                                <Link to={`/editorial/authors/${author._id}`} className="text-primary text-decoration-none">
                                    {author.firstName.toUpperCase()} <br/>
                                    <small>{author.lastName.toUpperCase()}</small>
                                </Link>
                            </strong>
                            <hr style={{ margin:'1px 0px' }}/>
                            <p className="card-text" style={{textAlign:'left'}}>
                                <small className="text-muted">
                                    <small dangerouslySetInnerHTML={{__html: truncate(author.description) }}/><br/>
                                    (<Link to={`/editorial/authors/${author._id}`} 
                                        className="text-primary" style={{cursor:'pointer', textDecoration:'underline'}} 
                                        onClick={()=>console.log(author)}>
                                        Ver más
                                    </Link>)
                                </small>
                            </p>
                        </Card.Body>
                    </Col>
                </Row>
            </Card>
        </Col>
    );
};
